const dateSceen = [{
  img: '03',
  numberQuestion: 5,
}, {
  img: '013',
  numberQuestion: 0,
}, {
  img: '019',
  numberQuestion: 0,
}, {
  img: '035',
  numberQuestion: 0,
}, {
  img: '044',
  numberQuestion: 0,
}, {
  img: '049',
  numberQuestion: 0,
}, {
  img: '060',
  numberQuestion: 0,
}, {
  img: '070',
  numberQuestion: 0,
}, {
  img: '080',
  numberQuestion: 0,
}, {
  img: '090',
  numberQuestion: 0,
}];

export default dateSceen;
